// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3yIR4","content":"styles_content__9Sz23","selectAll":"styles_selectAll__3Rvhy"};